import { useCallback, useState } from 'react';
import { ethers } from 'ethers';
import { useWallet } from 'use-wallet';

function useERC20Approve(contract, spender, amount = ethers.constants.MaxUint256) {
  const [loading, setLoading] = useState(false);
  const { account } = useWallet();

  const onApprove = useCallback(async () => {
    try {
      setLoading(true);
      return await contract.methods.approve(spender, amount).
        send({ from: account });
    } catch (e) {
      return false;
    } finally {
      setLoading(false);
    }
  }, [
    account,
    amount,
    contract,
    spender,
  ]);

  return [
    onApprove,
    loading,
  ];
}

export default useERC20Approve;
